import type { SeedingCampaignStatus } from '../types';

/**
 * 진행 단계 상단 H1 카피 매핑 (모집형 + 제안형 union).
 *
 * - delivered / contentRegistered 는 countdown H1 로 대체되어 여기 매핑하지 않음.
 * - recruiting / applied / closedSelecting 는 H1 미노출.
 *
 * 사용: `<CampaignInfo.Title>{PROGRESS_TITLE_BY_STATUS[status]}</CampaignInfo.Title>`
 */
export const PROGRESS_TITLE_BY_STATUS: Partial<Record<SeedingCampaignStatus, string>> = {
  // 모집형
  selected: '상품 준비 중',
  shipping: '상품 배송 중',
  rejected: '미선정',
  // 제안형
  preparing: '상품 준비 중',
  // shipping 키는 모집형과 동일 — 같은 카피 '상품 배송 중'
};
